<template>
  
  <!-- 같은 화면을 쓰는 게시판끼리 이동할 때(/list/campaign → /list/work_support) 화면을 새로 그리도록 key 지정 -->
  <router-view :key="$route.params.board_id || ''" />

</template>

<script>
import { notify } from 'vuetensils/src/components/VNotifications/VNotifications.vue'

export default {
  name: 'App',
  components: {

  },

  setup() {
    return {
      notify
    }
  },

  methods: {
    notify
  }
}
</script>
